module.exports = __webpack_public_path__ + "static/media/NotoSerifTC-Regular.8d04db88.woff2";